<script>
  import _base from '../../_default/components/_base.vue'
  import {merge as _merge} from 'lodash'
  import {Status as SocketStatus} from '../../../domain/leiloes/helpers/SocketStatus'
  import * as Status from '../../../domain/leiloes/helpers/LoteStatus'
  // import {number_format as numberFormat} from '../../../utils/helpers/phpjs'
  import Service from '../../../domain/leiloes/services/pregao'
  import WebSocket from '../../../domain/ws/service'
  import moment from 'moment'

  export default {
    name: 'PregaoLance',
    extends: _base,
    data () {
      return {
        leilao: {},
        pregao: null,
        lote: {
          numero: 0,
          imagem: null,
          descricao: '-',
          valorInicial: 0.00,
          valorIncremento: 0.00,
          valorMinimo: 0.00,
          valorMeta: 0.00,
          lancePrincipal: null,
          status: null,
          comitente: {
            pessoa: {}
          },
          pregao: null,
          lances: []
        },
        isLoading: false,
        centerContentFolded: false,
        hasNovoLance: false,
        countDownTimer: 10
      }
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
      Service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.isLoading = false
          this.leilao = response.data.leilao
          /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
           this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
           } */
          this.lote = response.data.lote
          this.pregao = response.data.pregao
          if (this.pregao !== null) {
            window.setTimeout(() => {
              this.centerContentFolded = true
              this.carregaPregao()
            }, 500)
          }
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
          window.responseError(response)
          console.log(response)
        })
    },
    computed: {
      lanceLocalidade: function () {
        return this.testHasProperty() ? this.lote.lancePrincipal.arrematante.pessoa.essencial.cidade + ' - ' + this.lote.lancePrincipal.arrematante.pessoa.essencial.uf : '-'
      },
      lanceData: function () {
        return this.testHasProperty() ? moment(this.lote.lancePrincipal.data.date).format('L') + ' ' + moment(this.lote.lancePrincipal.data.date).format('LTS') : '-'
      },
      valor: function () {
        return this.testHasProperty() ? this.lote.lancePrincipal.valor : 0
      },
      apelido: function () {
        return this.testHasProperty() ? this.lote.lancePrincipal.arrematante.apelido : '-'
      }
    },
    mounted () {
      this.wsChannel = 'pregao/' + this.$route.params.id
      this.ws = WebSocket.connect(process.env.WS_URL, (session) => {
        this.ws.inscrever(this.wsChannel, this.processRemoteMessage)
        console.log('Conectado WS')
      })
      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      this.$root.$el.classList.remove('full-height')
    },
    methods: {
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      testHasProperty: function () {
        return typeof this.lote.lancePrincipal !== 'undefined' && this.lote.lancePrincipal !== null && this.lote.lancePrincipal !== 'null'
      },
      toggleKeyboard (v) {
        this.centerContentFolded = v
      },
      processRemoteMessage: function (uri, payload) {
        console.log('Received message', payload)

        if (typeof payload.code === 'undefined') {
          return
        }

        let message = payload
        let code = message.code
        let token = message.token

        let queue = this.ws._socketQueue.indexOf(token)
        if (queue > -1) {
          this.ws._socketQueue.splice(queue, 1)
          console.log('message from me. nothing to do')
          return // nothing to do
        }

        if (code === SocketStatus.LANCE.code) {
          // Recebeu um lance novo
          this.remoteNovoLance(message.lote, message.lance)
        } else if (code === SocketStatus.LEILAO_ABERTO.code) {
          // Leilão foi aberto
          if (this.pregao === null) {
            // Carrega o pregão
            this.carregaPregao()
          }
        } else if (code === SocketStatus.LOTE_STATUS_UPDATED.code) {
          // Status do lote alterado
          if (this.lote.id !== message.lote.id) {
            console.log('Solicitação de atualizar status recebida, porém, nada a fazer pois o lote não é o mesmo da tela')
            return
          }

          delete this.lote.pregao
          _merge(this.lote, message.lote)
          this.mountTimerCountdown()
        } else if (code === SocketStatus.LANCE_DELETADO.code) {
          if (this.lote.id !== message.lote) {
            console.log('Solicitação de apagar lance recebida, porém, nada a fazer pois o lote não é o mesmo da tela')
            return
          }
          for (let i = 0, len = this.lote.lances.length; i < len; i++) {
            console.log('Verificando lance', this.lote.lances[i])
            if (parseInt(this.lote.lances[i]['id']) === parseInt(message.lance)) {
              console.log('Deletando lance...')
              /* if (typeof this.lote.lancePrincipal['id'] !== 'undefined') {
               if (parseInt(this.lote.lancePrincipal['id']) === parseInt(message.lance)) {
               if (this.lote.lances.length > 1) {
               this.lote.lancePrincipal = this.lote.lances[this.lote.lances.indexOf(this.lote.lances[i]) + 1]
               } else {
               this.lote.lancePrincipal = null
               }
               }
               } */
              Service.getLancePrincipal(this.lote.id)
                .then((response) => {
                  if (response.data.lote === this.lote.id) {
                    this.lote.lancePrincipal = response.data.lancePrincipal
                  } else {
                    console.log('Lance deletado porém o lote não é o mesmo na tela')
                  }
                })
                .catch((response) => {
                  window.responseError(response)
                  console.log(response)
                })
              this.lote.lances.splice(this.lote.lances.indexOf(this.lote.lances[i]), 1)
              break
            }
          }
        } else if (code === SocketStatus.LOTE_ALTERADO.code) {
          this.carregaPregao()
        } else if (code === SocketStatus.LEILAO_TIMER_ALTERADO.code) {
          this.reajustaTimerPregao(message.timer)
        } else if (code === SocketStatus.LOTE_RENOVAR_TEMPO.code) {
          if (this.lote.pregao !== null) {
            this.lote.pregao.dataAbertura = message.bind.data
            if (this.lote.lances.length > 0) {
              this.lote.lances[0].data = message.bind.data
            }
            this.$nextTick(() => {
              this.mountTimerCountdown()
            })
          }
        }
      },
      reajustaTimerPregao: function (newTimer) {
        this.leilao.timerPregao = this.countDownTimer = newTimer
        this.$nextTick(() => {
          this.mountTimerCountdown()
        })
        console.log('Reajustando timer do pregão')
      },
      carregaPregao: function () {
        let that = this
        Service.find(this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.isLoading = false
            this.leilao = response.data.leilao
            /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
             this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
             } */
            this.lote = response.data.lote
            this.pregao = response.data.pregao
            if (this.pregao !== null) {
              window.setTimeout(() => {
                this.centerContentFolded = true
                that.$nextTick(function () {
                  if (typeof that.leilao['timerPregao'] !== 'undefined') {
                    that.updateDefaultTimerPregao(that.leilao['timerPregao'])
                    that.mountTimerCountdown()
                  }
                })
              }, 500)
            }
            window.setTimeout(() => {
              Service.getStatsPregao(this.leilao.id)
                .then((response) => {
                  console.log(response.data)
                  this.stats = response.data
                })
                .catch((error) => {
                  console.log(error)
                }, 2000)
            })
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },
      reset: function () {
        this.countDownTimer = 10
      },
      updateDefaultTimerPregao: function (seconds) {
        this.countDownTimer = parseInt(seconds)
      },
      mountTimerCountdown: function () {
        // nothing to do
      },
      remoteNovoLance: function (lote, lance) {
        if (this.lote.id !== lote) {
          return // Lance não é deste lote
        }
        let that = this
        this.hasNovoLance = true
        this.$nextTick(function () {
          window.setTimeout(function () {
            that.hasNovoLance = false
          }, 100)
        })

        this.lote.lances.unshift(lance)
        this.lote.lancePrincipal = lance
        this.mountTimerCountdown()
        if (this.lote.status > 1 && this.lote.status < 5) {
          this.lote.status = Status.STATUS_EM_PREGAO
        }
        if (this.lote.lances.length > 5) {
          this.lote.lances.splice((this.lote.lances.length - 1), 1)
        }
      },
      calcPercentTimer: function (percent) {
        let downTimer = this.timerPregao
        return (downTimer * (percent / 100))
      }
    },
    components: {}
  }
</script>

<template>
  <div class="h-full">
    <div class="acompanhamento-lance h-full" :class="{'isLoading': isLoading, isOnline: apelido !== 'PLATEIA' && apelido !== '-'}">

      <div class="info">
        <div class="lote-numero col0">Lote {{ lote.numero }}</div>
        <div class="tipoLance col0"><span v-if="apelido !== 'PLATEIA'">Online</span><span v-else>PLATEIA</span></div>
      </div>

      <div class="lance">
        <div class="col">
          <div class="lbl">Lance Atual</div>
          <div class="box valorAtual" :class="{novoLance: hasNovoLance}">{{ valor | moeda }}</div>
        </div>
        <div class="col arrematante">
          <div class="lbl">Arrematante</div>
          <div class="box">
            <p class="apelido" v-if="apelido !== 'PLATEIA' && apelido !== '-'">{{ apelido }}</p>
            <p class="localidade">{{ lanceLocalidade }}</p>
            <p class="data">{{ lanceData }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?c5a6a734